import(/* webpackMode: "eager", webpackExports: ["default"] */ "/calcom/apps/web/modules/apps/installed/[category]/installed-category-view.tsx");
